import { render, staticRenderFns } from "./EventType.vue?vue&type=template&id=73f0c555&scoped=true"
import script from "./EventType.vue?vue&type=script&lang=js"
export * from "./EventType.vue?vue&type=script&lang=js"
import style0 from "./EventType.vue?vue&type=style&index=0&id=73f0c555&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f0c555",
  null
  
)

export default component.exports